/**
 * Duration formatting utilities
 * Formats duration in seconds to HH:MM:SS format
 */

/**
 * Format duration in seconds to "HH:MM:SS" format
 * Example: 68522 seconds -> "19:02:02"
 */
export const formatDuration = (seconds: number | undefined): string => {
  if (seconds === undefined || seconds === null || isNaN(seconds)) {
    return '00:00:00';
  }

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
};
